import { PAGE_INFO_FIELDS } from "@/graphql/pagination";
import { gql } from "@apollo/client";

export const TEAM_MEMBER_FIELDS = gql`
  fragment TeamMemberFields on OrganisationTeamMemberType {
    id
    inviteId
    organisationPractitionerId
    created
    accepted
    lastSent
    firstName
    lastName
    email
    roles {
      id
      permissions
    }
  }
`;

export const ORGANISATION_PRACITITIONER_LIST_QUERY = gql`
  query OrganisationPractitionerListQuery(
    $organisation: ID!
    $page: Int
    $orderBy: String
    $search: String
  ) {
    teamMembersPagination(
      organisation: $organisation
      page: $page
      orderBy: $orderBy
      search: $search
    ) {
      items {
        ...TeamMemberFields
      }
      pageInfo {
        ...PageInfoFields
      }
    }
  }
  ${TEAM_MEMBER_FIELDS}
  ${PAGE_INFO_FIELDS}
`;

export const INVITE_PRACTITIONER_TO_ORGANISATION_MUTATION = gql`
  mutation InvitePractitionerToOrganisationMutation(
    $input: InvitePractitionerToOrganisationMutationInput!
  ) {
    invitePractitionerToOrganisationMutation(input: $input) {
      errors {
        field
        messages
      }
      organisationPractitionerInvite {
        id
        recipientIsExistingPractitioner
      }
    }
  }
`;

export const ACCEPT_PATIENT_INVITE_PAGE_PROPS_QUERY = gql`
  query AcceptPatientInvitePagePropsQuery($patientId: ID!, $token: String!) {
    acceptPatientInvitePageProps(patientId: $patientId, token: $token) {
      pageProps
      hasExpired
      justExpired
      organisationPatientInvite
    }
  }
`;

export const ORGANISATION_PRACTITIONER_INVITE_DETAIL_QUERY = gql`
  query OrganisationPractitionerInviteDetailQuery($id: ID!, $token: String!) {
    acceptOrganisationInvitePageProps(id: $id, token: $token)
  }
`;

export const UPDATE_PRACTITIONER_ROLE_MUTATION = gql`
  mutation UpdatePractitionerRoleMutation($input: UpdatePractitionerRoleMutationInput!) {
    updatePractitionerRoleMutation(input: $input) {
      teamMember {
        ...TeamMemberFields
      }
      errors {
        field
        messages
      }
    }
  }
  ${TEAM_MEMBER_FIELDS}
`;
